import { ForwardRefExoticComponent, RefAttributes } from "react";
import { Clock, Filter, LucideProps, TrendingUp } from "lucide-react";

type Feature = {
	uuid: string;
	title: string;
	description: string;
	icon: ForwardRefExoticComponent<Omit<LucideProps, "ref"> & RefAttributes<SVGSVGElement>>;
};

export const parentalFeatures: Feature[] = [
	{
		uuid: "a196be26-fd2f-4e36-84b8-ab34915c18f3",
		icon: Clock,
		title: "Flexible Learning Schedule",
		description: "Learn at your own pace with 24/7 access to courses and adaptive scheduling that fits your lifestyle.",
	},
	{
		uuid: "a196be26-fd39-47e5-bf10-8a42f5968aab",
		icon: TrendingUp,
		title: "Real-time Progress Tracking",
		description: "Monitor your learning journey with detailed analytics, completion rates, and skill development insights.",
	},
	{
		uuid: "a196be26-fd3d-4eab-8290-9d58aaff63a2",
		icon: Filter,
		title: "Content filtering",
		description: "Age-appropriate courses and content filtering for safe learning.",
	},
];
